<template>
  <div class="leftTop">
    <div class="item mr-11px" style="margin-top:24px">
      <div>
        <div class="title" :class="menuItem.ecTransRank ? 'setCursor' : ''" @click="showModel('getCrossBorderEnterprise','1')">跨境电商</div>
        <div class="center-item">
          <div class="center-item-left">交易总额</div>
          <div class="center-item-right">{{(summary.totalTransaction / 10000).toFixed(2) || 0 | formatNumber}}万</div>
        </div>
        <div class="center-item">
          <div class="center-item-left">今日入园</div>
          <div class="center-item-right">{{summary.totayEnterNum || 0 | formatNumber}}家</div>
        </div>
        <div class="center-item">
          <div class="center-item-left">入园总数</div>
          <div class="center-item-right">{{summary.allEnterNum || 0 | formatNumber}}家</div>
        </div>
        <div class="title2">
          <div>交易额Top5</div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, i) of summary.top5List" :key="i">
            <div class="icon" :style="{'background': colors[i]}"><div>{{i + 1}}</div></div>
            <div class="text">{{item.customerName}}</div>
            <div class="line" :style="{'background': colors[i], 'width': item.width || '86px'}">
              <div class="circle" :style="{'background': colors[i]}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item" style="margin-top:24px">
      <div>
        <div class="title" :class="menuItem.nonEcTransRank ? 'setCursor' : ''" @click="showModel('getCrossBorderEnterprise','2')">非跨境电商</div>
        <div class="center-item">
          <div class="center-item-left">交易总额</div>
          <div class="center-item-right">{{(noCrossSummary.totalTransaction / 10000).toFixed(2) || 0 | formatNumber}}万</div>
        </div>
        <div class="center-item">
          <div class="center-item-left">今日入园</div>
          <div class="center-item-right">{{noCrossSummary.totayEnterNum || 0 | formatNumber}}家</div>
        </div>
        <div class="center-item">
          <div class="center-item-left">入园总数</div>
          <div class="center-item-right">{{noCrossSummary.allEnterNum || 0 | formatNumber}}家</div>
        </div>
        <div class="title2">
          <div>交易额Top5</div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, i) of noCrossSummary.top5List" :key="i">
            <div class="icon" :style="{'background': colors[i]}"><div>{{i + 1}}</div></div>
            <div class="text">{{item.customerName | isEmptyVal}}</div>
            <div class="line" :style="{'background': colors[i], 'width': item.width || '86px'}">
              <div class="circle" :style="{'background': colors[i]}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const {mapState, mapMutations} = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        ecTransRank: false, // 跨境电商交易额TOP排名
        nonEcTransRank: false // 非跨境电商交易额TOP排名
      },
      formData: {},
      topSummary: [],
      noCrossSummary: {
        top5List: []
      },
      topNoCrossSummary: [],
      summary: {
        top5List: []
      },
      colors: ['#F8B551', '#B3D465', '#80C269', '#32B16C', '#13B5B1'],
      initObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
      this.init2()
    }
  },

  created () {
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.ecTransRank = common.isShowItem('ecTransRank', setListMenu)
      this.menuItem.nonEcTransRank = common.isShowItem('nonEcTransRank', setListMenu)
    }
  },

  mounted () {
    this.init()
    this.init2()
    this.initObj = setInterval(() => {
      this.init() // 跨境电商
      this.init2() // 非跨境电商
    }, 60000)
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    // 设置语言文字
    init () {
      let width = 84
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.home.leftTop.getTransactionTop,
        data: {
          'companyType': '1'
        }
      }).then(res => {
        if (res && res.data) {
          this.summary = res.data
          let topNoCrossSummary = res.data.top5List || []
          let nums = topNoCrossSummary.map(item => {
            return item.transaction
          })
          let max = Math.max.apply(null, nums)
          topNoCrossSummary.map(item => {
            item.width = ((item.transaction / max) * width) + 'px'
          })
        }
      })
    },
    init2 () {
      let width = 84
      this.$ajax({
        method: 'post',
        // url: apiPath.bigData.home.getCompanyStatistics,
        url: apiPath.bigData.home.leftTop.getTransactionTop,
        data: {
          'companyType': '2'
          // pageIndex: 1,
          // pageSize: 10,
          // yearTime: this.homeTime
        }
      }).then(res => {
        if (res && res.data) {
          this.noCrossSummary = res.data
          let topNoCrossSummary = res.data.top5List || []
          let nums = topNoCrossSummary.map(item => {
            return item.transaction
          })
          let max = Math.max.apply(null, nums)
          topNoCrossSummary.map(item => {
            item.width = ((item.transaction / max) * width) + 'px'
          })
        }
      })
    },
    showModel (url, companyType) {
      let that = this
      if (companyType === '1') {
        if (!this.menuItem.ecTransRank) return
        this.setModelInfo({
          modelUrl: url,
          method: 'post',
          companyType: companyType,
          title: '跨境电商企业交易额TOP排名',
          headList: [
            {
              name: '今日入驻',
              value: that.summary.totayEnterNum || 0,
              unit: '（家）'
            }, {
              name: '入驻总量',
              value: that.summary.allEnterNum || 0,
              unit: '（家）'
            }, {
              name: '交易总额',
              value: (that.summary.totalTransaction / 10000).toFixed(2) || 0,
              unit: '（万）'
            }
          ],
          model: true
        })
      } else {
        if (!this.menuItem.nonEcTransRank) return
        this.setModelInfo({
          modelUrl: url,
          method: 'post',
          companyType: companyType,
          title: '非跨境电商企业交易额TOP排名',
          headList: [
            {
              name: '今日入驻',
              value: that.noCrossSummary.totayEnterNum || 0,
              unit: '（家）'
            }, {
              name: '入驻总量',
              value: that.noCrossSummary.allEnterNum || 0,
              unit: '（家）'
            }, {
              name: '交易总额',
              value: (that.noCrossSummary.totalTransaction / 10000).toFixed(2) || 0,
              unit: '（万）'
            }
          ],
          model: true
        })
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
  .leftTop{
    width: calc(454px - 48px);
    height: 291px;
    padding: 0 30px 0px 30px;
    display:flex;
    background: url('~@/assets/images/home/canvas-bg.png') no-repeat 0 0;
    background-size:100% 100%;
    .item{
      width: 198px;
      height: 100%;
      .title{
        background: url('~@/assets/images/home/model-head.png') no-repeat 0 0;
        background-size:100% 100%;
        width: 100%;
        height: 29px;
        font-size: 18px;
        line-height: 29px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        text-align: center;
        color: #00FAFF;
      }
      .center-item{
        display: flex;
        width: 198px;
        height: 24px;
        margin:6px 0;
        align-items: center;
        background: url('~@/assets/images/home/leftTop-lineBg.png') no-repeat 0 0;
        background-size:100% 100%;
        .center-item-left{
          margin: 0 13px 0 11px;
          width: 56px;
          letter-spacing: 2px;
          font-size: 10px;
        }
        .center-item-right{
          font-size: 14px;
          font-family: BB Strata;
          font-weight: normal;
          color: #00FAFF;
          line-height: 48px;
        }
      }
      .title2{
        background: url('~@/assets/images/home/leftTop-lineBg2.png') no-repeat 0 0;
        background-size:100% 100%;
        // width: 66px;
        height: 18px;
        width: 198px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #F2F2F2;
        line-height: 8px;
        margin-top:10px;
        div{
          padding-top:6px;
          padding-left: 26px;
        }
      }
      .list{
        margin-left: 10px;
        margin-top: 6px;
        .item{
          display: flex;
          align-items: center;
          margin-bottom:10px;
          .icon{
            width: 16px;
            height: 12px;
            position: relative;
            text-align: center;
            font-size: 10px;
            transform: skew(-20deg);
            background: red;
            div{
              position: absolute;
              top: 44%;
              left:50%;
              transform: translate(-50%, -50%);
            }
          }
          .text{
            margin: 0 8px 0 16px;
            font-size: 10px;
            line-height: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex: 1;
          }
          .line{
            width: 86px;
            height: 5px;
            position: relative;
            background: linear-gradient(0deg, rgba(52,234,146,0) 0%, #2B98C8 100%);
            .circle{
              position: absolute;
              top: 14%;
              right:-8px;
              transform: translateY(-50%);
              width: 16px;
              height: 16px;
              background: linear-gradient(0deg, #25BCC9 0%, #20FFE7 100%);
              opacity: 0.2;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .mr-11px{
      margin-right:11px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/leftTop.vue